import { ThemeProvider, createTheme } from '@mui/material/styles';
import KenColors from '../Utils/Themes/kenColors';
import createCache from '@emotion/cache';

export function createEmotionCache() {
  return createCache({ key: 'mui', prepend: true });
}

const theme = createTheme({
  palette: {
    KenColors: { ...KenColors },
    primary: {
      light: '#E64B35',
      main: '#092682',
      dark: '#002884',
      contrastText: '#fff',
    },
    secondary: {
      light: '#ff7961',
      main: '#f44336',
      dark: '#ba000d',
      contrastText: '#000',
    },
    error: {
      main: '#E75547',
    },
    success: {
      main: '#1BBE75',
    },
    card: {
      backgroundColor: '#F7F8FB',
      hover: '#EDF2FF',
    },
    labels: {
      main: '#061938',
      light: '#7A869A',
      medium: '#505F79',
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          fontFamily: "'Nunito', sans-serif",
        },
      },
    },
    MuiLinearProgress: {
      styleOverrides: {
        root: {
          borderRadius: '16px',
          height: '0.3rem',
          '@media (max-width: 1440px)': {
            height: '0.2rem',
          },
          '@media (max-width: 600px)': {
            height: '0.3rem',
          },
        },
        bar2Buffer: {
          background: '#F1F1F1',
          borderRadius: '16px',
        },
        bar1Buffer: {
          background: '#ADE05B',
          borderRadius: '16px',
        },
      },
    },
  },
  typography: {
    fontFamily: "'Roboto', serif",
    fontSize: 14,
    fontWeightLight: 300,
    fontWeightRegular: 400,
    fontWeightMedium: 500,
    body1: {
      fontSize: [16, '!important'],
    },
    body2: {
      fontSize: 18,
      fontWeight: 500,
    },
    body3: {
      fontSize: 14,
      fontWeight: 600,
    },
    body4: {
      fontSize: 14,
    },
    body5: {
      fontSize: 16,
      fontWeight: 600,
    },
    body6: {
      fontSize: 16,
    },
    body7: {
      fontSize: 18,
    },
    body8: {
      fontSize: 18,
      fontWeight: 600,
    },
    body9: {
      fontSize: 24,
      fontWeight: 600,
    },
    caption: {
      fontSize: [14, '!important'],
    },
    caption1: {
      fontSize: [12, '!important'],
    },
    subtitle1: {
      fontSize: '12px',
      fontWeight: 500,
    },
    subtitle2: {
      fontSize: '14px',
    },
    subtitle3: {
      fontSize: '20px',
    },
    subtitle4: {
      fontSize: '28px',
    },
    h1: {
      fontSize: '48px',
    },
    h2: {
      fontSize: '40px',
    },
    h3: {
      fontSize: '32px',
    },
    h4: {
      fontSize: '24px',
    },
    h5: {
      fontSize: '16px',
    },
    h6: {
      fontSize: '8px',
    },
  },
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 900,
      lg: 1200,
      xl: 1536,
      tablet: 769,
    },
  },
});

export default function GlobalThemeProvider(props) {
  const { children } = props;
  return <ThemeProvider theme={theme}>{children}</ThemeProvider>;
}
